(ns ballot-scout-v2-frontend.layout.page-content
  (:require
   [ballot-scout-v2-frontend.components.icon :as icon :refer [icon]]
   [ballot-scout-v2-frontend.events :as events]
   [ballot-scout-v2-frontend.layout.header :refer [logo]]
   [ballot-scout-v2-frontend.layout.header.views :refer [header]]
   [ballot-scout-v2-frontend.layout.sidebar.views :refer [mobile-sidebar sidebar]]
   [ballot-scout-v2-frontend.subs :as subs]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn landing-page
  [content]
  [:div#splashscreen {:class "mt-3 has-text-centered"}
   [:div {:class "level-item"} [logo]]
   [:div {:class "has-text-weight-bold has-text-dark"}
    content]])

(defn logging-in-page
  []
  [landing-page
   [:div.loading
    [:img.centered-img {:style {:padding "2em"} :src "/images/compass-100x100.png"}]
    [:p "Logging you in to Ballot Scout"]]])

(defn banner
  []
  [:div {:class ["banner" "is-flex" "is-align-items-center" "has-background-link" "top-0"]}
   [:div {:class ["button-in" "is-flex" "is-justify-content-center"]}
    [:div
     "We want to know what you think!"
     [:a {:class ["mx-1" "has-text-white" "has-text-underlined"]
          :href "https://www.ballotscout.org/survey-fall-2022"
          :target "_blank"}
      [:strong "Take our 10 min Survey"]]
     "or"
     [:a {:class ["ml-1" "has-text-white" "has-text-underlined"]
          :href "https://calendly.com/ekruse-2"
          :target "_blank"}
      [:strong "Schedule a Feedback Session"]]]
    [:button {:class "clear"
              :type "button"
              :on-click #(rf/dispatch [::events/hide-banner])}
     [icon ::icon/times {:class "has-text-white"}]]]])

(defn page-content []
  (let [children (r/children (r/current-component))
        show-banner? (rf/subscribe [::subs/show-banner?])]
    [:<>
     (when @show-banner? [banner])
     [header]
     [:div.sidebar-and-content.columns
      [mobile-sidebar]
      [sidebar]
      (into [:div {:class ["page-content" "column" "is-10" (if @show-banner? "top-6" "top-4")]}]
            children)]]))
